import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ManageMaintenanceAlertsComponent } from '../manage-maintenance-alerts/manage-maintenance-alerts.component';

@Component({
  selector: 'app-maintenance-alerts',
  templateUrl: './maintenance-alerts.component.html',
  styleUrls: ['./maintenance-alerts.component.scss'],
})
export class MaintenanceAlertsComponent implements OnInit {
  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {}

  openManageMaintenancePopup(data?) {
    this.dialog.open(ManageMaintenanceAlertsComponent, {
      width: '385px',
      disableClose: true,
      data: {
        type: data && data.type ? data.type : 'addMortgage',
        title: data && data.title ? data.title : 'Add Mortgage',
        message: data && data.message ? data.message : 'Add missing mortgage to current property!',
        principal: data && data.principal ? data.principal : null,
        interest: data && data.interest ? data.interest : '',
        term: data && data.term ? data.term : '',
        startDate: data && data.startDate ? data.startDate : '',
        id: data && data.id ? data.id : null,
      },
    });
  }
}
